export const scrollToTop = (top = 0) => {
  window.scrollTo({ top, behavior: 'smooth' });
};

export const scrollToBottom = () => {
  window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
};

/**
 * Scrolls the window to a specific pixel position.
 *
 * @param {number} px - The vertical pixel position to scroll to
 * @param {'auto' | 'smooth'} behavior - The scroll behavior (default: 'smooth')
 * @returns {void}
 *
 * @example
 * ```typescript
 * // Scroll to 500px from top
 * scrollToPx(500);
 *
 * // Scroll to 1000px with instant behavior
 * scrollToPx(1000, 'auto');
 * ```
 */
export const scrollToPx = (px: number, behavior: 'auto' | 'smooth' = 'smooth'): void => {
  window.scrollTo({ top: px, behavior });
};



